<template>
  <div>
    <section>
      <!-- Componentes externos -->
      <crear-actualizar-cas />
      <ver-documento />
      <h3 class="primary--text">
        <v-icon color="primary">restore</v-icon> CAS
      </h3>
      <v-card>
        <v-card-text>
          <crud-table
            :headers="headers"
            :url="url"
            :filters="filters"
            :data-graphql="dataGraphql"
            :graphql="graphql"
            :initData="initData"
          >
            <!-- Template injectable de la cabecera de la tabla -->
            <template slot="buttons">
              <v-tooltip bottom>
                <v-btn
                v-if="estado==1"
                  color="primary"
                  dark
                  @click.native.stop="crearActualizarCas({})"
                  slot="activator"
                  ><v-icon dark>add</v-icon> {{ $t("common.add") }}</v-btn
                >
                <span>Agregar CAS</span>
              </v-tooltip>
            </template>

            <!-- Template de filas y columnas -->
            <template slot="items" slot-scope="items">
              <!-- Agregar las columnas que consideré necesarias -->

              <td class="text-xs-center">
                {{ $moment(items.item.fecha_presentacion).format("DD/MM/YYYY")}}
              </td>
              <td class="text-xs-center">{{ $moment(items.item.fecha_tramite).format("DD/MM/YYYY") }}</td>
              <td class="text-xs-center">{{ items.item.anios }}</td>
              <td class="text-xs-center">{{ items.item.meses }}</td>
              <td class="text-xs-center">{{ items.item.dias }}</td>
              <td class="text-xs-center">
                <v-tooltip bottom v-if="estado==1 && items.item.id_estado ==1">
                  <v-btn
                    icon
                    slot="activator"
                    @click.native="crearActualizarCas(items.item)"
                    color="primary"
                    
                    >
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <span>Editar registro</span>
                </v-tooltip>
                 <v-tooltip bottom>
                  <v-btn
                    icon
                    slot="activator"
                    @click.native="verDocumento(items.item)"
                    color="green"
                    dark
                  >
                    <v-icon>visibility</v-icon>
                  </v-btn>
                  <span>Ver registro</span>
                </v-tooltip>
                  <v-tooltip bottom v-if="estado==1 && items.item.id_estado ==1">
                  <v-btn
                    icon
                    slot="activator"
                    @click.native="deleteItem(items.item.id, 'cas')"
                    color="red"
                    dark
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                  <span>Eliminar registro</span>
                </v-tooltip>

              </td>
              
            </template>
          </crud-table>
        </v-card-text>
      </v-card>
    </section>
  </div>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import CrearActualizarCas from "../dialogs/CrearActualizarCas.vue"; // Componente de creación y actualización
import VerDocumento from '../dialogs/VerDocumento.vue';

export default {
  props: ['persona'],
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud],
  // Variables iniciales del componente
  data() {
    return {
      url: "cass",
      graphql: true, // Cabecera de la tabla
      headers: [
        // { text: 'Nombre de la cabecera', value: 'Campo que deseamos interpolar', align: 'center' },
        {
          text: "Fecha presentación en ASP-B",
          value: "fecha_presentacion",
          align: "center",
        },
        { text: "Fecha trámite CAS", value: "fecha_limite", align: "center" },
        {
          text: "Años calificados a la fecha",
          value: "anios",
          align: "center",
        },
        {
          text: "Meses calificados a la fecha",
          value: "meses",
          align: "center",
        },
        {
          text: "Dias calificados a la fecha",
          value: "dias",
          align: "center",
        },
        { text: this.$t("common.actions"), sortable: false, align: "center" },
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
        id
        id_estado
        fecha_tramite
        fecha_presentacion
        anios
        meses
        dias
        url_documento
        
        _user_created
        _user_updated
        _created_at
        _updated_at
      `,
      filters: [],
      estados_ficha:[],
      estado:[],
      initData: [
        {
          state: true,
          param: "id_persona",
          value: this.persona.id,
        },
      ],
      estado:[],
      rol:[]
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    this.$bus.$on("verDocumento", (item) => {
      this.url = item;
      this.dialog = true;
    });

    this.$bus.$on("closeDialog", () => {
      this.updateList();
    });
    this.obtenerEstadoFicha();
  },
  // Métodos y funciones del componente
  methods: {
    crearActualizarCas(item) {
      this.$bus.$emit("openDialogCrearActualizarCas", item);
    },
     async verDocumento(item) {
      this.$bus.$emit("openDialogVerDocumento", item);
    },
    async cambiarEstado(item) {
      let value = item.id_estado === "20" ? 1 : 20;
      let data = {
        id_estado: value,
      };
      try {
        await this.$service.graphql({
          query: `
            mutation edit($id: ID!, $cas: EditCas!) {
              casEdit(id: $id, cas: $cas) {
                id
              }
            }
          `,
          variables: {
            id: item.id,
            cas: data,
          },
        });
        if (value === 1) {
          this.$message.success("CAS habilitado");
        } else {
          this.$message.warning("CAS deshabilitado");
        }
        this.updateList();
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerEstadoFicha() {
      let user = this.$storage.get("user");
      this.rol=user.roles[0].id;
      let respuesta = await this.$service.graphql({
        query: `
          query{
                  vListafichas(id_persona:${user.id_persona}){
                    rows{
                      id_persona
                      nombre
                      nro_doc
                      id_estado_ficha
                      estado_ficha
                      habilitado
                      item
                      id_unidad
                      unidad      
                    }
                  }
                }
        `
      });
      this.estados_ficha = respuesta.vListafichas.rows;
      this.estado=this.estados_ficha[0].habilitado
      let roles = user.roles;
      roles.forEach(element => {
      if(element.id==115){
        this.estado=1
      }
    });
      //console.log(this.estados_ficha[0].habilitado)
    },
  },
  // Definición de componentes importados
  components: {
    CrudTable,
    CrearActualizarCas,
    VerDocumento
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/admin/ficha_personal/components/Cas.vue